import * as React from 'react';
import { FC } from 'react';

import { Box } from '@rbilabs/component-library';

import ActionButton, { ActionButtonVariants } from 'components/action-button';

import {
  Body,
  ButtonContainer,
  Header,
  ItemText,
  StyledModal,
  StyledPicture
} from './modal-item-unavailable.styled';
import { IModalItemUnavailableViewProps } from './types';

export const ModalItemUnavailableView: FC<IModalItemUnavailableViewProps> = ({
  handleContinue,
  handleChangeStore,
  unavailableItemName,
  header,
  image,
  selectNewBtnText,
  continueBtnText,
  body,
  imageAlt,
  hideSelectNewBtn
}) => (
  <StyledModal
    mParticleEventData={{
      modalAppearanceEventMessage: 'Static menu item unavailable'
    }}
    data-testid="item-unavailable-static-menu"
    allowsDismiss={false}
  >
    <Header>{header}</Header>
    <Body>{body}</Body>
    <StyledPicture alt={imageAlt} image={image} />
    <ItemText>{unavailableItemName?.toUpperCase()}</ItemText>
    <ButtonContainer>
      <Box margin="0 0.25rem">
        <ActionButton onClick={handleContinue}>{continueBtnText}</ActionButton>
      </Box>
      {!hideSelectNewBtn && (
        <Box margin="1.5rem 0.25rem 0">
          <ActionButton variant={ActionButtonVariants.INVERSE} onClick={handleChangeStore}>
            {selectNewBtnText}
          </ActionButton>
        </Box>
      )}
    </ButtonContainer>
  </StyledModal>
);
